<style lang="less">
.center {
  width: 100%;
  height: 102%;
  margin-top: -27px;

  .center1 {
    width: 100%;
    height: 100%;

    .ivu-checkbox-inner {
      border-color: #000000;
      background-color: rgba(9, 53, 73, 0.5);
    }

    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #1ce59b;
      background-color: #1ce59b;
    }

    .center1_1 {
      // width: 100%;
      height: 40px;

      .center1_1xj {
        // width: 100%;
        height: 30px;
      }
    }

    .center1_2 {
      width: 100%;
      height: 100px;
      overflow: auto;
      padding: 0px 6px 0px 0px;

      .Maintenance_Event_nrbxz {
        background-color: rgba(87, 88, 87, 0.5);
        // color: rgba(255, 255, 255, 1);
        color: #000;
      }

      .Maintenance_Event_nrxz {
        background-color: rgba(222, 222, 222, 0.9);
        // color: rgba(255, 255, 255, 1);
        color: #000;
      }

      .Maintenance_Event_nryy {
        // linear-gradient(rgba(204, 193, 193, 0.8), rgba(17, 97, 122, 0.1), rgba(17, 97, 122, 0))
        // background-color:rgba(17,97,122,0.4);
        background: -webkit-linear-gradient(
          rgba(204, 193, 193, 0.8),
          rgba(204, 193, 193, 0.1),
          rgba(204, 193, 193, 0)
        );
        /* Safari 5.1-6.0 */
        background: -o-linear-gradient(
          rgba(204, 193, 193, 0.8),
          rgba(204, 193, 193, 0.1),
          rgba(204, 193, 193, 0)
        );
        /* Opera 11.1-12.0 */
        background: -moz-linear-gradient(
          rgba(204, 193, 193, 0.8),
          rgba(204, 193, 193, 0.1),
          rgba(204, 193, 193, 0)
        );
        /* Firefox 3.6-15 */
        background: linear-gradient(
          rgba(204, 193, 193, 0.8),
          rgba(204, 193, 193, 0.1),
          rgba(204, 193, 193, 0)
        );
        /* 标准语法 */
        color: rgba(0, 0, 0, 0.1);

        img {
          opacity: 0.1;
        }
      }

      .Maintenance_Event_nr {
        border-top-left-radius: 20px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 5px;
        padding: 15px 10px 0px 15px;
        width: 100%;
        margin: 0px 0px 15px 0px;

        .Maintenance_Event_nr_1 {
          width: 100%;
        }

        .Maintenance_Event_nr_2 {
          font-size: 14px;

          .Maintenance_Event_nr_2_1 {
            padding: 1px 0px;
            width: 100%;

            div:nth-child(odd) {
              width: 36%;
            }

            div:nth-child(even) {
              padding: 0px 0px 0px 5px;
              width: 64%;
            }
          }
        }

        .Maintenance_Event_nr_3 {
          height: 15px;
          width: 100%;
        }
      }
    }
  }
}

.STEPNAME_sty {
  background: rgba(128, 187, 128, 0.5) !important;
}

.modal_ty {
  margin-top: 15px;
}

.modal_sty {
  background-color: rgba(28, 229, 155, 0.6);
  border-radius: 5px;
  margin-top: 5px;
}

.modal_sty_a {
  background-color: rgba(229, 176, 28, 0.4);
  border-radius: 5px;
  margin-top: 5px;
}

.sty_a {
  height: 100px;
  margin-top: 10px;
  border: 1px solid #d0d3d7;
  color: #d0d3d7;
  text-align: center;
  border-radius: 5px;
}

.weight_f {
  font-weight: 600;
}

.ivu-checkbox-wrapper {
  margin-right: 0px !important;
}

.spancolor {
  color: #e3e3e3;
}
textarea.ivu-input {
  resize: none;
}

// #cancelbtn {}

// #confirmbtn {
//     width: 40px;
//     height: 25px;
//     background-color: #57a3f3;
//     border-color: #57a3f3;
//     padding: 2px 7px;
//     font-size: 12px;
//     border-radius: 3px;
// }
</style>

<template>
  <div class="center">
    <div class="center1 display_column">
      <div style="margin-left: 200px;margin-bottom: 10px;">
        <Checkbox v-model="mytask.flag" @on-change="GetTableData">我的任务</Checkbox>
        <span>【</span>
        <span style="color:#FF6600;font-size: 16px;font-weight: bolder;">{{ mytask.content }}条</span>
        <span>】</span>
      </div>
      <div v-show="!this.mytask.flag">
        <!--输入框 年份-->
        <div class="display_row_js">
          <div class="center1_1 dispaly_flex00">
            <Input
              search
              @on-search="GetTableData"
              placeholder="输入项目名称"
              v-model="keywords"
              @on-enter="GetTableData"
              style="width:220px;"
            ></Input>
          </div>
          <div style="display:flex;align-items: center;">
            <div style="width:40px;height:30px;">
              <span>年份</span>
            </div>
            <div style="height:40px;" class="display_row_ac">
              <Select
                v-model="yeartime"
                style="width:85px;height:30px;"
                size="small"
                @on-change="GetTableData('1')"
              >
                <Option v-for="year in yearList" :value="year.PROYEAR">
                  {{
                  year.PROYEAR
                  }}
                </Option>
              </Select>
            </div>
          </div>
        </div>
        <!--单位 状态-->
        <div style="margin-bottom: 10px;" class="display_row_js">
          <!-- <div class="display_row_js"> -->
          <div style="display:flex;align-items: center;" v-show="dcinfo">
            <div style="width:35px;">
              <span>单位</span>
            </div>
            <div class="display_row_ac">
              <Select
                v-model="dwid"
                filterable
                size="small"
                style="width:185px;"
                @on-change="GetTableData('1')"
              >
                <Option v-for="dw in dwList" :value="dw.value" :key="dw.value">{{ dw.label }}</Option>
              </Select>
            </div>
          </div>

          <div style="display:flex;align-items: center;">
            <div style="width:40px;">
              <span>状态</span>
            </div>
            <div style class="display_row_ac">
              <Select
                v-model="stateid"
                style="width:85px;"
                size="small"
                @on-change="GetTableData('1')"
              >
                <Option v-for="sl in stateList" :value="sl.value" :key="sl.value">{{ sl.label }}</Option>
              </Select>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <!--类别、新建、导出-->
        <div style="margin-bottom: 10px;" class="display_row_js_ac">
          <div class="display_row">
            <div>
              <span>类别</span>
            </div>
            <div style="margin-left:2px;" class="display_row_ac">
              <CheckboxGroup @on-change="GetTableData" v-model="type">
                <Checkbox
                  style="margin-left:6px;"
                  v-for="item in typeList"
                  :key="item.label"
                  :label="item.value"
                >{{ item.label }}</Checkbox>
              </CheckboxGroup>
            </div>
          </div>
          <div class="center1_1xj display_row_je">
            <div
              @click="adddata"
              class="gcbtndiv display_row_ac"
              style="margin-right:10px"
              v-show="addNewPro && prjend"
            >
              <img src="../../../../static/images/ic_new_02.png" style="margin-right:5px" />
              <span>新建申报项目</span>
            </div>
            <div
              class="gcbtndiv display_row_ac"
              @click="daochu"
              v-show="dcinfo"
              style="margin-right:10px"
            >
              <img src="../../../../static/images/ic_export.png" style="margin-right:5px" />
              <span>导出</span>
            </div>
          </div>
        </div>
      </div>

      <div class="center1_2 dispaly_flex11" v-scroll="onSriolly" v-show="flag">
        <div
          v-for="(item, i) in listData"
          class="Maintenance_Event_nr"
          :flag="item.active"
          :key="i"
          @click="changestyle(i, item)"
          :class="{
            Maintenance_Event_nrbxz: item.active == true && item.top == true,
            Maintenance_Event_nrxz: item.active == false && item.top == true,
            Maintenance_Event_nryy: item.top == false
          }"
        >
          <div class="display_row_js Maintenance_Event_nr_1 media_w_w18">
            <div class="display_row_ac">
              <img
                v-show="!item.active"
                style="margin-right:10px"
                src="../../../../static/images/ic_engineering_01.png"
              />
              <img
                v-show="item.active"
                style="margin-right:10px"
                src="../../../../static/images/ic_engineering_02.png"
              />
              <span>{{ item.PRJNAME }}</span>
            </div>
            <div class="display_row_je_ac media_w_w14">
              <div
                style="background:#80bb80;width:90px;text-align:center;"
                :class="{ STEPNAME_sty: item.top == false }"
              >
                <span>{{ item.STEPNAME }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="Maintenance_Event_nr_2" style="margin-top: 10px;">
            <div class="Maintenance_Event_nr_2_1 display_row media_w_w12">
              <div>
                <span class="spancolor">项目类别：{{item.TYPENAME}}</span>
              </div>
              <div>
                <span class="spancolor">所属单位：{{item.DWMC}}</span>
              </div>
            </div>
            <div class="Maintenance_Event_nr_2_1 display_row media_w_w12">
              <div>
                <span class="spancolor">负责人：{{item.FZRNAME}}</span>
              </div>
              <div v-show="item.CONTRACTNUM!=0">
                <span class="spancolor">项目编号：{{item.CONTRACTNUM}}</span>
              </div>
            </div>            
          </div>-->
          <div style="margin-top:10px;" class="display_row_je" v-show="!(item.STEP == 24)">
            <div
              v-show="
                (item.STEP >= 8 && item.STEP <= 12) ||
                  (item.STEP >= 18 && item.STEP <= 20) ||
                  item.STEP == 13 ||
                  (item.STEP >= 25 && item.STEP <= 28 && item.STEP != 27) ||
                  item.STEP == 23
              "
            >
              <Tooltip
                :content="
                  item.STEP >= 8 && item.STEP <= 13
                    ? '合同下载'
                    : item.STEP >= 15 && item.STEP <= 21
                    ? '验收资料下载'
                    : '验收小结下载'
                "
              >
                <img
                  :src="url.url4"
                  style="margin-right:10px;"
                  @click="ht_download(i, item, $event)"
                />
              </Tooltip>
            </div>
            <div v-show="!(item.STEP == 5)">
              <Tooltip content="操作">
                <img :src="url.url3" style="margin-right:10px;" @click="caozuo(i, item, $event)" />
              </Tooltip>
            </div>
            <div
              v-show="
                !(item.STEP == 5) &&
                  item.CREATEUSER == createuser &&
                  !(item.STEP > 7)
              "
            >
              <Tooltip content="修改">
                <img :src="url.url1" style="margin-right:10px;" @click="xiugai(i, item, $event)" />
              </Tooltip>
            </div>
            <div v-show="!(item.STEP > 5) && expertinfo != 1">
              <Tooltip content="删除">
                <img :src="url.url2" style="margin-right:10px;" @click="delprj(item)" />
              </Tooltip>
            </div>
          </div>
          <div :id="item.guid" class="Maintenance_Event_nr_3"></div>
        </div>
      </div>
    </div>
    <div>
      <Modal v-model="model_dw" title="审核">
        <div slot="footer">
          <Button @click="modal_cancel_a">取消</Button>
          <Button @click="modal_chushen">确定</Button>
        </div>
        <Row>
          <span>审核状态：</span>
          <RadioGroup v-model="STEPID" style="margin-left:10px">
            <Radio v-for="sh in sh_state_3" :label="sh.value" :key="sh.value">
              {{
              sh.label
              }}
            </Radio>
          </RadioGroup>
        </Row>
        <Row>
          <div class="modal_ty">
            <Col span="4">
              <span>审核意见：</span>
            </Col>
            <Col span="20">
              <Input v-model="sh_opinion" type="textarea" :rows="4" placeholder="请填写审核意见" />
            </Col>
          </div>
        </Row>
      </Modal>

      <Modal v-model="model_ylj" width="600" title="审核">
        <div slot="footer">
          <Button @click="cancel">取消</Button>
          <Button @click="modal_yljshenhe">确定</Button>
        </div>
        <div v-show="flag_modal">
          <div>
            <Row>
              <Col span="4" class="weight_f">专家意见：</Col>
              <Col span="16">&nbsp;</Col>
              <Col span="3">
                <Button
                  type="info"
                  @click="add_zjinfo"
                  :disabled="isdisabledFn"
                  style="margin-top:-5px;"
                >添加专家</Button>
              </Col>
            </Row>
            <Row>
              <div class="sty_a" v-show="!show_a">
                <Col style="height:50px;margin-top:25px;" class="media_w_w16">
                  <span>请先添加专家</span>
                </Col>
              </div>
            </Row>
          </div>
          <div style="max-height:450px;overflow-y:auto;" v-show="show_a">
            <div v-for="(info, index) in data_zj_a" :key="index" class="modal_sty">
              <Row>
                <Col span="17" style="margin-top:8px;padding-left: 10px;" class="media_w_w18">
                  {{ info.USERNAME }}
                  <span>({{ info.DWMC }})</span>
                </Col>
                <Col
                  span="5"
                  class="media_w_w16"
                  style="margin-top:10px;margin-bottom:5px;"
                  v-show="pf_show"
                >
                  <Col span="10">评分：</Col>
                  <Col span="6">{{ info.GRADENUM }}</Col>
                </Col>
              </Row>
              <Row style="margin-top:0px;margin-bottom:0px;">
                <Col span="2" style=" margin-left: 10px;margin-bottom:5px;">意见：</Col>
                <Col span="19" style="margin-left:4px;margin-bottom:5px;">
                  {{
                  info.GRADEADIVCE
                  }}
                </Col>
              </Row>
            </div>
          </div>
          <div>
            <Row class="modal_ty">
              <Col span="24">
                <div style="display:flex;justify-content:space-between;">
                  <div>
                    <span class="weight_f">审核状态：</span>
                    <RadioGroup v-model="STEPID" style="margin-left:20px" @on-change="tip_info">
                      <Radio
                        v-for="sh in sh_state_3"
                        :label="sh.value"
                        :key="sh.value"
                        :disabled="isReadOnly"
                      >{{ sh.label }}</Radio>
                    </RadioGroup>
                  </div>
                  <span>
                    <Button size="small" type="default" @click="clear_info">清除</Button>
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <div class="modal_ty" v-show="STEPID != '6'">
                <Col span="4" class="weight_f">
                  <span>审核意见：</span>
                </Col>
                <Col span="20">
                  <Input
                    v-model.trim="sh_opinion_ylj"
                    type="textarea"
                    :rows="4"
                    placeholder="请填写审核意见"
                    :disabled="isReadOnly"
                  />
                </Col>
              </div>
            </Row>
            <Row>
              <div class="modal_ty" v-show="STEPID == '6'">
                <Col span="4">
                  <span>
                    <div style="margin-top:5px;" class="weight_f">项目编号：</div>
                  </span>
                </Col>
                <Col span="12">
                  <Input
                    v-model.trim="ht_number_ylj"
                    type="text"
                    placeholder="请输入项目编号"
                    :disabled="isReadOnly"
                  />
                </Col>
                <Col span="2">&nbsp;</Col>
                <Col span="6">
                  <Select v-model="typeid" style="width:100%" filterable :disabled="isReadOnly">
                    <Option
                      v-for="item in Type"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.label }}</Option>
                  </Select>
                </Col>
              </div>
            </Row>
          </div>
        </div>
        <div v-show="!flag_modal">
          <div>
            <Row>
              <Col span="10">
                <span style="padding-left:10px">姓名</span>
                <Input v-model="zj_name" style="width:180px;margin-left:12px" placeholder="请输入姓名" />
              </Col>
              <Col span="10">
                <span>单位</span>
                <Input v-model="zj_dw" style="width:180px;margin-left:12px" placeholder="请输入单位" />
              </Col>
              <Col span="2">
                <Button type="info" @click="getzj_info" style="margin-top:0px;margin-left:10px">查询</Button>
              </Col>
            </Row>
          </div>
          <div style="height:350px;max-height:450px;overflow-y:auto;">
            <div v-for="info in data_zj" class="modal_sty_a">
              <Row style="margin-top:5px;">
                <Col span="1" style="margin-left:15px;margin-top:13px;">
                  <Checkbox v-model="info.zj_check"></Checkbox>
                </Col>
                <Col span="21" style="margin-left: 10px;">
                  <Row style="margin-top:10px;margin-bottom:5px;">
                    <Col span="12" class="weight_f">专家姓名：{{ info.USERNAME }}</Col>
                    <Col span="12">所属单位：{{ info.DWMC }}</Col>
                  </Row>
                  <Row style="margin-top:5px;margin-bottom:8px;">
                    <Col span="4">科研方向：</Col>
                    <Col span="19" style="margin-left:-12px">
                      {{
                      info.REMARK
                      }}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Modal>

      <Modal v-model="model_zjdf" @on-ok="modal_ok_zjdf" @on-cancel="modal_cancel" title="专家评审">
        <Row v-show="zjdf_show">
          <span>专家评分：</span>
          <Input
            v-model="zjdf_value"
            placeholder="0~100分"
            type="number"
            style="margin-left:7px;width:83%;"
          />
        </Row>
        <Row>
          <div class="modal_ty">
            <Col span="4">
              <span>专家意见：</span>
            </Col>
            <Col span="20">
              <Input v-model="sh_opinion" type="textarea" :rows="4" placeholder="请填写审核意见" />
            </Col>
          </div>
        </Row>
      </Modal>

      <Modal v-model="model_scht" title="信息上传">
        <div>
          <Row>
            <Col span="5" style="margin-top:5px">
              <span style="padding-left:0px">{{ titlename }}上传：</span>
            </Col>

            <!-- :on-success="successLoad"
            :show-upload-list="false"-->
            <Col span="9">
              <Upload
                :action="fileAction"
                :before-upload="handleUpload"
                :multiple="show_htinfo"
                ref="uploadfile"
              >
                <div @click="updata(this)">
                  <Tooltip content="上传" placement="top">
                    <Button icon="ios-cloud-upload-outline">上传</Button>
                  </Tooltip>
                </div>
              </Upload>
            </Col>
            <Col
              span="10"
              style="margin-top:5px"
              v-show="pronumber.length != 0"
            >项目编号：{{ pronumber }}</Col>
          </Row>
          <!-- <div
            v-for="(item,index) in filenick"
            :key="index"
            style="width: 240px;margin-left: 100px;"
          >{{item}}</div>-->
        </div>
        <div slot="footer">
          <Button type="error" @click="modal_cancel">取消</Button>
          <!-- id="cancelbtn" id="confirmbtn"-->
          <Button type="primary" @click="modal_ok_scht">确定</Button>
        </div>
      </Modal>

      <Modal
        v-model="model_lrTime"
        @on-ok="modal_ok_lrTime"
        @on-cancel="modal_cancel"
        title="录入时间信息"
        width="400"
      >
        <div>
          <span>
            中期时间:
            <DatePicker type="date" v-model="zq_time" style="width:80%"></DatePicker>
          </span>
        </div>
        <div style="margin-top:15px">
          <span>
            验收时间:
            <DatePicker type="date" v-model="ys_time" style="width:80%"></DatePicker>
          </span>
        </div>
      </Modal>

      <Modal v-model="model_sj" @on-ok="modal_ok" @on-cancel="modal_cancel" title="收件">
        <Row>
          <Col span="6" style="margin-top:5px">
            <span>园林局收件：</span>
          </Col>
          <Col span="10">
            <div>
              <Tooltip content="确认收件" placement="top">
                <Button @click="modal_ok_sj">确认收件</Button>
              </Tooltip>
            </div>
          </Col>
        </Row>
      </Modal>

      <Modal v-model="model_yssq" @on-ok="modal_ok" @on-cancel="modal_cancel" title="验收申请">
        <Row>
          <Col span="6" style="margin-top:5px">
            <span>单位验收申请：</span>
          </Col>
          <Col span="10">
            <div>
              <Tooltip content="确认申请" placement="top">
                <Button @click="modal_ok_yssq">确认申请</Button>
              </Tooltip>
            </div>
          </Col>
        </Row>
      </Modal>

      <Modal v-model="model_xmwj" @on-ok="modal_ok" @on-cancel="modal_cancel" title="项目完结">
        <Row>
          <Col span="6" style="margin-top:5px">
            <span>项目信息：</span>
          </Col>
          <Col span="10">
            <div>
              <Tooltip content="项目完结" placement="top">
                <Button @click="modal_ok_xmwj">项目完结</Button>
              </Tooltip>
            </div>
          </Col>
        </Row>
      </Modal>

      <Modal v-model="model_cxtj" @on-ok="modal_ok_cxtj" @on-cancel="modal_cancel" title="审核">
        <Row>
          <Col span="6" style="margin-top:5px">
            <span>信息提交：</span>
          </Col>
          <Col span="10">
            <div>
              <Button>是否重新提交</Button>
            </div>
          </Col>
        </Row>
      </Modal>
    </div>
  </div>
</template>

<script>
import bus from "../../../app/event";
// import center_head from "./center_head.vue";//节点预警
export default {
  components: {
    // center_head
  },
  data() {
    return {
      stateList: [
        { label: "全部", value: "-1" },
        { label: "初审通过", value: "3" },
        { label: "终审通过", value: "6" },
        { label: "合同终审通过", value: "14" },
        { label: "收件完成", value: "16" },
        { label: "项目完结", value: "24" }
      ], //状态列表
      stateid: "-1", //状态id
      prjend:appurl.isaddpro,
      sign: false, //用于添加的标志
      proid: "", //接收项目id
      initflag: false,
      timer: null, //定时器
      dwid: "", //单位id
      dwList: [], //单位
      yeartime: "",
      yearList: [], //年份
      dcinfo: false, //导出
      typeid: "", //类型展示值id
      Type: [], //选择类型
      tn: "", //下载信息的标题
      titlename: "", //标题名称
      pronumber: "", //项目编号
      addNewPro: false, //创建申报项目
      isReadOnly: false, //是否只读
      createuser: "", //创建人的usercode
      expertinfo: "", //专家信息
      show_htinfo: false, //上传合同信息，是否可以多选
      pf_show: true, //评分是否展示
      flag_modal: true,
      zjdf_show: true,
      df_ID: "",
      file: null,
      zj_name: "", //筛选===专家姓名
      zj_dw: "", //筛选===专家所在单位
      show_a: false, //用于选择专家的提示
      ht_name: "科技项目合同.text", //用于传合同信息
      fileAction: "",
      data_zj_a: [], //用于接收选择的专家信息
      zq_time: "", //中期时间
      ys_time: "", //验收时间
      onledata: "", //通过 操作按钮 获取当前对应的唯一数据

      isdisabledFn: false, //判断添加按钮是否可用
      zjdf_value: "", //专家打分的值
      STEPID: "", //审核状态对应的值，
      sh_state_3: [], //接收项目阶段步骤信息
      sh_opinion: "", //审核意见
      sh_opinion_ylj: "", //园林局审核意见
      ht_number_ylj: "", //合同编号
      data_zj: [], //初始化 专家信息
      model_dw: false, //单位初审
      model_ylj: false, //园林局
      choose_zj: false, //选择专家
      model_zjdf: false, //专家打分
      model_sj: false, //园林局收件
      model_scht: false, //上传合同
      model_lrTime: false, //录入时间
      model_yssq: false, //验收申请
      model_xmwj: false, //项目完结
      model_cxtj: false, //重新提交
      listData: [],
      url: {
        url1: "./static/images/ic_edit.png",
        url2: "./static/images/ic_delete.png",
        url3: "./static/images/操作.png",
        url4: "./static/images/ic_download.png"
      },
      urlhttp: false,
      flag: true,
      keywords: "", //搜索的关键词
      type: ["计划", "指导", "未定"],
      typeList: [
        {
          value: "计划",
          label: "计划"
        },
        {
          value: "指导",
          label: "指导"
        },
        {
          value: "未定",
          label: "未定"
        }
      ],
      mytask: {
        flag: false,
        content: "0"
      },
      filenick: []
    };
  },
  methods: {
    daochu: function() {
      if (this.dwid == 0) {
        this.dwid = "";
      }
      if (this.listData.length == 0) {
        this.$Message.success({
          content: "没有数据，不能导出",
          duration: 3
        });
        return;
      }
      window.open(
        appurl.ip +
          "/ylkjservice/services/hander.ashx?action=exportexcel&Year=" +
          this.yeartime +
          "&DWID=" +
          this.dwid +
          "&STEP=" +
          this.stateid +
          ""
      );

      // this.$http
      //   .post(
      //     appurl.ip + "/ylkjservice/services/hander.ashx?action=exportexcel",
      //     {
      //       Year: this.yeartime,
      //       DWID: this.dwid
      //     }
      //   )
      //   .then(response => {
      //     if (response.status == 200) {
      //       this.$Message.success({ content: "数据导出成功", duration: 3 });
      //       this.initDW();
      //     }
      //   })
      //   .catch(error => {
      //     this.$Message.warning({ content: "请求失败", duration: 3 });
      //   });
    },
    //获取年份
    getYear() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=generalsql",
          {
            FILED: "PROYEAR",
            TABLENAME: "PRO_INFO",
            SQLWHERE: "1=1 group by PROYEAR"
          }
        )
        .then(res => {
          if (res.status == 200) {
            if (res.data.length > 0) {
              _this.yearList = res.data;
              _this.yeartime = _this.yearList[0].PROYEAR;
              _this.GetTableData();
            } /* else{
              this.$Message.warning({
                content: "暂无数据！",
                duration: 3
              });
            } */
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //获取单位
    initDW() {
      var _this = this;
      this.$http
        .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=listorg", {
          SSDW: sessionStorage.getItem("SSDW"),
          AOTHOR_ID: sessionStorage.getItem("AOTHOR_ID")
        })
        .then(res => {
          if (res.status == 200) {
            _this.dwList.push({
              label: "全部",
              value: 0
            });
            for (let i = 0; i < res.data.length; i++) {
              let obj = {};
              obj.label = res.data[i].DWMC;
              obj.value = res.data[i].ID;
              _this.dwList.push(obj);
            }
            _this.dwid = _this.dwList[0].value;
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //提示信息
    tip_info() {
      if (this.STEPID == 5) {
        this.$Message.warning({
          content: "终审不通过，该项目将不能再进行申报！",
          duration: 3
        });
      }
      if (this.STEPID == 7) {
        this.$Message.warning({
          content: "终审退回，该项目将退回到申报单位管理员处",
          duration: 2
        });
      }
    },

    //合同下载
    ht_download(i, item, event) {
      var _this = this;
      if (
        (item.STEP >= 8 && item.STEP <= 13) ||
        (item.STEP >= 25 && item.STEP <= 28) ||
        item.STEP == 23
      ) {
        this.$http
          .post(
            appurl.ip +
              "/ylkjservice/services/hander.ashx?action=getprofiledetail",
            {
              PRJNAME: item.PRJNAME,
              ID: item.ID,
              StageName: "temp"
            }
          )
          .then(response => {
            if (response.status == 200) {
              let data = response.data;
              if (data.length == 0) {
                this.$Message.warning({
                  content: "暂无下载资料信息！",
                  duration: 3
                });
                return;
              } else {
                // let name = [];
                // for (let i = 0; i < data.length; i++) {
                //   name = data[i].filename;
                // }
                let name = data[0].filename;
                let downurl =
                  appurl.downfile +
                  "/projectmanager/" +
                  item.PRJNAME +
                  "_" +
                  item.ID +
                  "/temp/" +
                  name;
                window.open(downurl);
              }
            }
          })
          .catch(error => {
            this.$Message.warning({
              content: "请求失败",
              duration: 3
            });
          });
      } else {
        this.$http
          .post(
            appurl.ip +
              "/ylkjservice/services/hander.ashx?action=getprofiledetail",
            {
              PRJNAME: item.PRJNAME,
              ID: item.ID,
              StageName: "temp"
            }
          )
          .then(response => {
            if (response.status == 200) {
              let data = response.data;
              if (data.length == 0) {
                this.$Message.warning({
                  content: "暂无合同信息！",
                  duration: 3
                });
                return;
              } else {
                let name = [];
                for (let i = 0; i < data.length; i++) {
                  name.push(data[i].filename);
                  // name = data[i].filename;
                  // let downurl =
                  //   appurl.downfile +
                  //   "/projectmanager/" +
                  //   item.PRJNAME +
                  //   "_" +
                  //   item.ID +
                  //   "/temp/" +
                  //   name;
                  // window.open(downurl);
                }
                this.$http
                  .post(
                    appurl.ip +
                      "/ylkjservice/services/hander.ashx?action=downloadzipfile",
                    {
                      FileName: name.toString(),
                      PRJNAME: item.PRJNAME,
                      ID: item.ID,
                      StageName: "temp"
                    }
                  )
                  .then(response => {
                    if (response.status == 200) {
                      let data = response.data;
                      let msg = data.msg;
                      let name = data.name;
                      let downurl = appurl.downfile + name;
                      window.open(downurl);
                    }
                  })
                  .catch(error => {
                    this.$Message.warning({
                      content: "请求失败",
                      duration: 3
                    });
                  });
              }
            }
          })
          .catch(error => {
            this.$Message.warning({
              content: "请求失败",
              duration: 3
            });
          });
      }
    },

    adddata: function() {
      if (appurl.isaddpro) {
        //菜单
        bus.$emit("to_theme", ["new_information"], true, true);
        //
        bus.$emit("center_to", "新增", undefined);
      } else {
        this.$Message.warning({
          content: "项目申报已截止！",
          duration: 3
        });
      }
    },
    //颜色--点击变色
    yashi: function(item) {
      var arr = this.listData;
      for (let i = 0; i < arr.length; i++) {
        arr[i].active = false;
      }
      item.active = true;
      this.flag = false;
      this.flag = true;
    },
    //操作弹出框点击取消按钮
    modal_cancel() {
      this.model_scht = false;
    },
    modal_cancel_a() {
      this.model_dw = false;
    },
    cancel() {
      this.flag_modal ? (this.model_ylj = false) : (this.flag_modal = true);
    },
    modal_ok() {},
    //初审
    modal_chushen() {
      if (this.STEPID == "") {
        this.$Message.warning({
          content: "您还没有选择审核状态！",
          duration: 3
        });
        return;
      }
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=conformpro",
          {
            PRJNAME: this.onledata.PRJNAME, //项目名称
            ADVICE: this.sh_opinion, //审核意见
            ID: this.onledata.ID, //选中行数据的id
            AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
            USERCODE: this.$store.state.user.USERCODE, //当前用户登录的USERCODE
            STEPID: this.STEPID //审核的步骤
          }
        )
        .then(res => {
          if (res.status == 200 && res.data.success == "true") {
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
      this.model_dw = false;
    },
    //园林局终审
    zhongshen_info() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=conformpro",
          {
            PRJNAME: this.onledata.PRJNAME, //项目名称
            ADVICE: this.sh_opinion_ylj, //审核意见
            ID: this.onledata.ID, //选中行数据的id
            AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
            USERCODE: this.$store.state.user.USERCODE, //当前用户登录的USERCODE
            STEPID: this.STEPID //审核的步骤
          }
        )
        .then(res => {
          if (res.status == 200 && res.data.success == "true") {
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //更新合同信息
    updata_ht() {
      this.$http
        .post(
          appurl.ip +
            "/ylkjservice/services/hander.ashx?action=updatecontractnum",
          {
            ID: this.onledata.ID, //选中行数据的id
            CONTRACTNUM: this.ht_number_ylj, //合同编号
            PRJTYPE: this.typeid //项目名称
          }
        )
        .then(res => {
          if (res.status == 200 && res.data.success == true) {
            this.$Message.success({
              content: "填写项目编号成功！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //园林局审核
    modal_yljshenhe() {
      if (this.flag_modal) {
        //审核界面
        if (this.onledata.STEPNAME == "园林局终审") {
          if (this.STEPID == "") {
            this.$Message.warning({
              content: "您还没有选择审核状态！",
              duration: 3
            });
            return;
          }
          if (this.STEPID == "6") {
            if (this.ht_number_ylj.length == 0) {
              this.$Message.warning({
                content: "请输入项目编号",
                duration: 3
              });
              return;
            } else {
              this.zhongshen_info();
              this.updata_ht();
            }
          } else {
            this.zhongshen_info();
          }
          //园林局终审
        } else if (this.onledata.STEPNAME == "初审通过") {
          if (
            this.STEPID == "" &&
            this.data_zj_a.length != 0 &&
            this.sign == false
          ) {
            this.$Message.warning({
              content: "您已选择过专家！不可再次添加",
              duration: 3
            });
            return;
          }
          //园林局不审核，选择专家
          if (
            this.STEPID == "" &&
            this.data_zj_a.length != 0 &&
            this.sign == true
          ) {
            var _this = this;
            var zj_usercode = [];
            if (this.data_zj_a.length > 1) {
              for (let i = 0; i < this.data_zj_a.length; i++) {
                zj_usercode.push(this.data_zj_a[i].USERCODE);
              }
            }
            this.$http
              .post(
                appurl.ip +
                  "/ylkjservice/services/hander.ashx?action=saveproexpert",
                {
                  ID: this.onledata.ID, //选中项目的id
                  USERCODE: zj_usercode.toString(), //专家的USERCODE
                  SENDUSERCODE: this.$store.state.user.USERCODE, //当前登录人的USERCODE
                  STEPID: this.onledata.STEP //所属阶段步骤
                }
              )
              .then(res => {
                if (res.status == 200 && res.data.success == "true") {
                  _this.sign = false;
                  _this.GetTableData();
                }
              })
              .catch(error => {
                this.$Message.warning({
                  content: "访问失败！",
                  duration: 3
                });
              });
          } else {
            if (this.STEPID == "") {
              this.$Message.warning({
                content: "您还没有选择审核状态！",
                duration: 3
              });
              return;
            }
            // //不选择专家，不能直接审核通过,可退回，可不通过
            // if (this.STEPID == "6") {
            //   this.$Message.warning({
            //     content: "该项目未经专家审核，不能直接通过！",
            //     duration: 3
            //   });
            //   return;
            // } else {
            //   this.zhongshen_info();
            // }

            //不选择专家，审核通过
            if (this.STEPID == "6") {
              if (this.ht_number_ylj.length == 0) {
                this.$Message.warning({
                  content: "请输入项目编号",
                  duration: 3
                });
                return;
              } else {
                this.zhongshen_info();
                this.updata_ht();
              }
            } else {
              this.zhongshen_info();
            }
          }
        } else if (this.onledata.STEPNAME == "合同初审通过") {
          if (
            this.STEPID == "" &&
            this.data_zj_a.length != 0 &&
            this.sign == false
          ) {
            this.$Message.warning({
              content: "您已选择过专家！不可再次添加",
              duration: 3
            });
            return;
          }
          //园林局不审核，选择专家
          if (
            this.STEPID == "" &&
            this.data_zj_a.length != 0 &&
            this.sign == true
          ) {
            var _this = this;
            var zj_usercode = [];
            if (this.data_zj_a.length > 0) {
              for (let i = 0; i < this.data_zj_a.length; i++) {
                zj_usercode.push(this.data_zj_a[i].USERCODE);
              }
            }
            this.$http
              .post(
                appurl.ip +
                  "/ylkjservice/services/hander.ashx?action=saveproexpert",
                {
                  ID: this.onledata.ID, //选中项目的id
                  USERCODE: zj_usercode.toString(), //专家的USERCODE
                  SENDUSERCODE: this.$store.state.user.USERCODE, //当前登录人的USERCODE
                  STEPID: this.onledata.STEP //所属阶段步骤
                }
              )
              .then(res => {
                if (res.status == 200 && res.data.success == "true") {
                  _this.sign = false;
                  _this.GetTableData();
                }
              })
              .catch(error => {
                this.$Message.warning({
                  content: "访问失败！",
                  duration: 3
                });
              });
          } else {
            if (this.STEPID == "") {
              this.$Message.warning({
                content: "您还没有选择审核状态！",
                duration: 3
              });
              return;
            }
            // 不选专家，不能直接通过
            // if (this.STEPID == 14) {
            //   this.$Message.warning({
            //     content: "该项目未经专家审核，不能直接通过！",
            //     duration: 3
            //   });
            //   return;
            // } else {
            //   this.zhongshen_info();
            // }
            this.zhongshen_info();
          }
        } else if (this.onledata.STEPNAME == "合同终审") {
          if (this.STEPID == "") {
            this.$Message.warning({
              content: "您还没有选择审核状态！",
              duration: 3
            });
            return;
          }
          this.zhongshen_info();
        }
        this.model_ylj = false;
      } else {
        //选择专家界面
        this.check_sth();
      }
    },
    //专家打分
    modal_ok_zjdf() {
      var _this = this;
      var abc = 0;
      if (this.onledata.STEP == 3) {
        if (
          this.zjdf_value >= 0 &&
          this.zjdf_value <= 100 &&
          this.zjdf_value != ""
        ) {
          abc = this.zjdf_value;
        } else {
          this.$Message.warning({
            content: "满分100分，请输入正确的分数",
            duration: 3
          });
          return;
        }
      }
      if (this.sh_opinion.length < 1) {
        this.$Message.warning("专家的意见不能为空！");
        return;
      }
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=expertgrade",
          {
            ID: this.df_ID,
            GRADENUM: abc, //专家打分数
            GRADEADIVCE: this.sh_opinion, //专家建议
            PID: this.onledata.ID, //当前选中的项目ID
            STEPID: this.onledata.STEP, //选中课题的步骤
            USERCODE: this.$store.state.user.USERCODE //当前用户登录的USERCODE
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.$Message.success({
              content: "专家审核成功！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //上传合同
    modal_ok_scht(file) {
      this.model_scht = false;
      // this.GetTableData();
      this.$refs.uploadfile.clearFiles();
      setTimeout(() => {
        // this.file = null;
        this.GetTableData();
        // this.$Message.success("上传成功");
      }, 500);
    },
    //录入时间
    modal_ok_lrTime() {
      var _this = this;
      this.$http
        .post(
          appurl.ip +
            "/ylkjservice/services/hander.ashx?action=updatecontracttime",
          {
            ID: this.onledata.ID, //选中项目的id
            MIDDLETIME: this.formatDateTime(this.zq_time), //中期时间
            ACCEPTTIME: this.formatDateTime(this.ys_time) //验收时间
          }
        )
        .then(res => {
          if (res.status == 200 && res.data.success == "true") {
            this.$Message.success({
              content: "录入时间信息节点成功！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //园林局确认收件
    modal_ok_sj() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=contractover",
          {
            ID: this.onledata.ID, //选中行数据的id
            PRJNAME: this.onledata.PRJNAME //课题名称
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.$Message.success({
              content: "确认收件成功！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //申报单位验收申请
    modal_ok_yssq() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=conformpro",
          {
            PRJNAME: this.onledata.PRJNAME, //项目名称
            ADVICE: "申请验收", //审核意见
            ID: this.onledata.ID, //选中行数据的id
            AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
            USERCODE: this.$store.state.user.USERCODE, //当前用户登录的USERCODE
            STEPID: "18" //审核的步骤
          }
        )
        .then(res => {
          if (res.status == 200) {
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //项目完结
    modal_ok_xmwj() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=conformpro",
          {
            PRJNAME: this.onledata.PRJNAME, //项目名称
            ADVICE: "项目验收完成，项目完结", //审核意见
            ID: this.onledata.ID, //选中行数据的id
            AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
            USERCODE: this.$store.state.user.USERCODE, //当前用户登录的USERCODE
            STEPID: "24" //审核的步骤
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.$Message.success({
              content: "项目完结！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //重新提交
    modal_ok_cxtj() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=conformpro",
          {
            PRJNAME: this.onledata.PRJNAME, //项目名称
            ADVICE: "项目已修改，并重新提交", //审核意见
            ID: this.onledata.ID, //选中行数据的id
            AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
            USERCODE: this.$store.state.user.USERCODE, //当前用户登录的USERCODE
            STEPID: "1" //审核的步骤
          }
        )
        .then(res => {
          if (res.status == 200) {
            this.$Message.success({
              content: "已修改，重新提交确认！",
              duration: 3
            });
            _this.GetTableData();
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },

    //操作
    caozuo: function(i, item, event) {
      this.isReadOnly = false;
      this.show_htinfo = false;
      this.pf_show = true;
      this.isdisabledFn = false;
      this.flag_modal = true;
      this.STEPID = "";
      this.sh_opinion = "";
      this.sh_opinion_ylj = "";
      this.ht_number_ylj = "";
      this.onledata = item;
      this.listexpertnum();
      this.getstep(item);
      this.get_zj_data();

      setTimeout(() => {
        this.caozuo_a(item);
      }, 300);

      event = event ? event : window.event;
      event.cancelBubble = true;
    },
    caozuo_a(item) {
      if (item.STEP == "1" || item.STEP == "7") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "园林局，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            // this.$Message.warning({
            //   content: "不是单位管理员，无操作权限！",
            //   duration: 3
            // });
            if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
              this.model_cxtj = true;
            } else {
              this.$Message.warning({
                content: "非本人申报项目，无操作权限！",
                duration: 3
              });
            }
          } else {
            this.model_dw = true;
          }
        }
      } else if (item.STEP == "2") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "初审不通过，需单位申报业务员，修改申报信息！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
              this.model_cxtj = true;
            } else {
              this.$Message.warning({
                content: "非本人申报项目，无操作权限！",
                duration: 3
              });
            }
          } else {
            this.$Message.warning({
              content: "初审不通过，需单位申报业务员，修改申报信息！",
              duration: 3
            });
          }
        }
      } else if (item.STEP == "3") {
        if (this.$store.state.user.EXPERT == 1) {
          if (this.df_ID != "") {
            this.model_zjdf = true;
          } else {
            this.$Message.warning({
              content: "该项目未分配您打分！",
              duration: 3
            });
          }
        } else {
          if (this.$store.state.user.AOTHOR_ID != 0) {
            //申报单位
            this.$Message.warning({
              content: "无操作权限！",
              duration: 3
            });
          } else {
            this.getType();
            // if (this.df_ID != "") {
            //   // this.isdisabledFn = true;
            // }
            if (this.data_zj_a.length == 0) {
              this.show_a = false;
              this.isdisabledFn = false;
            } else {
              this.isdisabledFn = true;
              // this.isReadOnly = true;
            }
            this.model_ylj = true;
          }
        }
      } else if (item.STEP == "4") {
        if (this.$store.state.user.EXPERT == 1) {
          this.$Message.warning({
            content: "专家，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.AOTHOR_ID != 0) {
            //不是园林局
            this.$Message.warning({
              content: "申报单位，无操作权限！",
              duration: 3
            });
          } else {
            this.getType();
            this.isdisabledFn = true;
            // this.get_zj_data();
            this.model_ylj = true;
          }
        }
      } else if (item.STEP == "6" || item.STEP == "10" || item.STEP == "13") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "园林局，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
              this.model_scht = true;
              this.titlename = "合同";
              this.pronumber = item.CONTRACTNUM;
            } else {
              this.$Message.warning({
                content: "非本人申报项目，无操作权限！",
                duration: 3
              });
            }
          } else {
            //是管理员
            //不是第13步，
            if (item.STEP != "13") {
              this.$Message.warning({
                content: "当前阶段需要业务员，上传合同信息",
                duration: 3
              });
            } else {
              this.model_dw = true;
            }
          }
        }
      } else if (item.STEP == "8") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //是园林局
          this.$Message.warning({
            content: "园林局，无操作权限，需要申报单位管理员操作！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 1) {
            //是管理员
            this.model_dw = true;
          } else {
            this.$Message.warning({
              content: "不是单位管理员，无操作权限！",
              duration: 3
            });
          }
        }
      } else if (item.STEP == "11" || item.STEP == "12") {
        if (this.$store.state.user.EXPERT == 1) {
          if (this.df_ID != "") {
            this.zjdf_show = false;
            this.model_zjdf = true;
          } else {
            if (item.STEP == "11") {
              this.$Message.warning({
                content: "该项目未分配您审核！",
                duration: 3
              });
            } else {
              this.$Message.warning({
                content: "该项目已审核完成！",
                duration: 3
              });
            }
          }
        } else {
          if (this.$store.state.user.AOTHOR_ID != 0) {
            //不是园林局
            this.$Message.warning({
              content: "申报单位，无操作权限！",
              duration: 3
            });
          } else {
            this.pf_show = false;
            if (this.data_zj_a.length == 0) {
              this.show_a = false;
              this.isdisabledFn = false;
            } else {
              this.isdisabledFn = true;
            }
            this.model_ylj = true;
          }
        }
      } else if (item.STEP == "14") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "园林局，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
              this.model_lrTime = true;
            } else {
              this.$Message.warning({
                content: "非本人申报项目，无操作权限！",
                duration: 3
              });
            }
          } else {
            this.$Message.warning({
              content: "需要单位业务员填写信息！",
              duration: 3
            });
          }
        }
      } else if (item.STEP == "15") {
        if (this.$store.state.user.AOTHOR_ID != 0) {
          //不是园林局
          this.$Message.warning({
            content: "申报单位，无操作权限！",
            duration: 3
          });
        } else {
          this.model_sj = true;
        }
      } else if (item.STEP == "16") {
        this.$Message.warning({
          content: "等待申报业务员上传资料！",
          duration: 3
        });
      } else if (item.STEP == "17" || item.STEP == "19" || item.STEP == "21") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "园林局，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            // this.model_yssq = true;
            if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
              this.show_htinfo = true;
              this.model_scht = true;
              this.titlename = "验收资料";
            } else {
              this.$Message.warning({
                content: "非本人申报项目，无操作权限！",
                duration: 3
              });
            }
          } else {
            if (item.STEP != "21") {
              this.$Message.warning({
                content: "需要单位业务员，提交验收申请！",
                duration: 3
              });
            } else {
              this.model_dw = true;
            }
          }
        }
      } else if (item.STEP == "18") {
        if (this.$store.state.user.AOTHOR_ID == 0) {
          //园林局
          this.$Message.warning({
            content: "园林局，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.ISADMIN == 0) {
            //不是管理员
            this.$Message.warning({
              content: "不是单位管理员，无操作权限！",
              duration: 3
            });
          } else {
            this.model_dw = true;
          }
        }
      } else if (item.STEP == "20") {
        if (this.$store.state.user.AOTHOR_ID != 0) {
          //不是园林局
          this.$Message.warning({
            content: "申报单位,无操作权限！",
            duration: 3
          });
        } else {
          this.model_dw = true;
        }
      } else if (item.STEP == "22" || item.STEP == "26" || item.STEP == "28") {
        if (this.$store.state.user.EXPERT == 1) {
          this.$Message.warning({
            content: "专家，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.AOTHOR_ID == 0) {
            //不是园林局
            this.$Message.warning({
              content: "园林局,无操作权限！",
              duration: 3
            });
          } else {
            if (this.$store.state.user.ISADMIN == 0) {
              //不是管理员
              // 需要申报单位业务员上传资料
              if (this.$store.state.user.USERCODE == this.onledata.USERCODE) {
                this.show_htinfo = false;
                this.model_scht = true;
                this.titlename = "验收小结";
              } else {
                this.$Message.warning({
                  content: "非本人申报项目，无操作权限！",
                  duration: 3
                });
              }
            } else {
              if (item.STEP == "28") {
                this.model_dw = true;
              }
            }
          }
        }
      } else if (item.STEP == "23") {
        if (this.$store.state.user.EXPERT == 1) {
          this.$Message.warning({
            content: "专家，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.AOTHOR_ID == 0) {
            //是园林局
            this.$Message.warning({
              content: "园林局,无操作权限！",
              duration: 3
            });
          } else {
            // // 园林局处理,项目完结
            // this.model_xmwj = true;
            if (this.$store.state.user.ISADMIN == 0) {
              //不是管理员
              this.$Message.warning({
                content: "不是单位管理员，无操作权限！",
                duration: 3
              });
            } else {
              this.model_dw = true;
            }
          }
        }
      } else if (item.STEP == "25") {
        if (this.$store.state.user.AOTHOR_ID != 0) {
          //不是园林局
          this.$Message.warning({
            content: "申报单位,无操作权限！",
            duration: 3
          });
        } else {
          this.model_dw = true;
        }
      } else if (item.STEP == "27") {
        if (this.$store.state.user.EXPERT == 1) {
          this.$Message.warning({
            content: "专家，无操作权限！",
            duration: 3
          });
        } else {
          if (this.$store.state.user.AOTHOR_ID != 0) {
            //不是园林局
            this.$Message.warning({
              content: "不园林局,无操作权限！",
              duration: 3
            });
          } else {
            // 园林局处理,项目完结
            this.model_xmwj = true;
          }
        }
      }
    },
    xiugai: function(i, item, event) {
      this.yashi(item);
      bus.$emit("to_theme", ["new_information"], true, false);
      bus.$emit("center_to", "修改", item);
      event = event ? event : window.event;
      event.cancelBubble = true;
    },
    changestyle: function(i, item) {
      this.proid = item.ID;
      this.yashi(item);
      bus.$emit("to_theme", ["detailed_information", "data_download"], true);
      let flag = item.STEPNAME == "收件完成" ? true : false;
      bus.$emit("center_to", "详细", item, i, flag);
      bus.$emit("getProId", item.ID, this.$store.state.user.AOTHOR_ID);
    },
    //获取列表数据
    GetTableData(data) {
      if (data == "1") {
        this.initflag = false;
      }
      if (sessionStorage.getItem("AOTHOR_ID") != 0) {
        if (sessionStorage.getItem("ISADMIN") == 0) {
          this.addNewPro = true;
        }
      } else {
        this.dcinfo = true;
      }

      let _this = this;
      let typelist = "";
      this.type.forEach(el => {
        if (el == "计划") {
          typelist += "1,";
        } else if (el == "指导") {
          typelist += "2,";
        } else if (el == "未定") {
          typelist += "0,";
        }
      });
      typelist = typelist.substring(0, typelist.length - 1);
      this.$http
        .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=listpro", {
          USERCODE: sessionStorage.getItem("USERCODE"),
          SSDW: sessionStorage.getItem("SSDW"),
          AOTHOR_ID: sessionStorage.getItem("AOTHOR_ID"),
          ISADMIN: sessionStorage.getItem("ISADMIN"),
          PRJNAME: this.keywords,
          EXPERT: sessionStorage.getItem("EXPERT"),
          SHOWMYTASK: this.mytask.flag ? 1 : 0,
          PRJTYPE: typelist,
          Year: this.yeartime,
          DWID: this.dwid,
          STEP: this.stateid //所有传-1
        })
        .then(res => {
          if (res.status == 200) {
            let rawdata = res.data;
            _this.listData = [];
            if (rawdata.length == 0) {
              // _this.$Message.warning("暂无数据");
              return;
            }
            rawdata.forEach((el, index) => {
              let obj = el;
              obj["active"] = false;
              obj["top"] = true;
              obj["chakan"] = "查看";
              obj["xiugai"] = "修改";
              obj["guid"] = "MaintenanceEvent" + (index + 1);
              _this.listData.push(el);
            });
            this.mytask.content = rawdata[0].mytaskcount;
            if (!this.initflag) {
              this.changestyle(0, this.listData[0]);
              this.initflag = true;
            } else {
              for (let j = 0; j < _this.listData.length; j++) {
                if (this.proid == _this.listData[j].ID) {
                  _this.listData[j].active = true;
                }
              }
            }
            _this.$nextTick(function() {
              _this.shadow(true);
              _this.urlhttp = false;
            });

            _this.createuser = _this.$store.state.user.USERCODE;
            _this.expertinfo = _this.$store.state.user.EXPERT;
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    onSriolly: function(item, aa) {
      var that = this;
      that.shadow(false);
    },
    shadow: function(item) {
      if (this.urlhttp == false || item == true) {
        var arr = this.listData;
        var judge = true;
        for (let i = 0; i < arr.length; i++) {
          var arry = document
            .getElementById(arr[i].guid)
            .getBoundingClientRect().top;
          if (arry < window.innerHeight * 0.99 - 40) {
            arr[i].top = true;
          } else {
            arr[i].top = false;
            judge = false;
          }
        }
      }
    },
    delprj: function(item) {
      if (this.$store.state.user.ISADMIN == 0) {
        if (this.$store.state.user.USERCODE != item.USERCODE) {
          this.$Message.warning({
            content: "非本人申报项目，无操作权限！",
            duration: 3
          });
          return;
        }
      }

      let ID = item.ID;
      let PRJNAME = item.PRJNAME;
      this.$Modal.confirm({
        title: "删除",
        content: "是否确认删除？",
        onOk: () => {
          this.$http
            .post(
              appurl.ip + "/ylkjservice/services/hander.ashx?action=delpro",
              {
                ID,
                PRJNAME
              }
            )
            .then(res => {
              if (res.status == 200 && res.data.success == true) {
                this.$Message.success("删除成功");
                this.GetTableData();
              } else {
                this.$Message.warning("删除失败");
              }
            })
            .catch(error => {
              this.$Message.warning({
                content: "访问失败！",
                duration: 3
              });
            });
        }
      });
    },
    //初始化专家信息
    getzj_info() {
      let _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=listexpert",
          {
            USERNAME: _this.zj_name,
            DWMC: _this.zj_dw
          }
        )
        .then(res => {
          if (res.status == 200) {
            _this.data_zj = [];
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].zj_check = false;
              _this.data_zj.push(res.data[i]);
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    add_zjinfo() {
      // 跳转--专家选择
      this.flag_modal = false;
      this.getzj_info();
    },
    //专家选择，
    check_sth() {
      this.clear_info();
      this.data_zj_a = [];
      for (var i = 0; i < this.data_zj.length; i++) {
        if (this.data_zj[i].zj_check == true) {
          this.data_zj_a.push(this.data_zj[i]);
        }
      }
      if (
        this.onledata.STEPNAME != "合同初审通过" &&
        this.onledata.STEPNAME != "合同终审"
      ) {
        if (this.data_zj_a.length < 3) {
          this.$Message.warning({
            content: "最少选择三位专家",
            duration: 3
          });
          this.choose_zj = true;
          return;
        } else {
          this.show_a = true;
          this.flag_modal = true;
          this.isReadOnly = true;
        }
      } else {
        this.show_a = true;
        this.flag_modal = true;
        this.isReadOnly = true;
      }
      this.sign = true;
    },
    //获取到打分后的专家信息(多个专家信息)
    get_zj_data() {
      let _this = this;
      this.data_zj_a = [];
      var stepid_a = 0;
      if (this.onledata.STEP == 3 || this.onledata.STEP == 4) {
        stepid_a = 3;
      } else {
        stepid_a = 11;
      }
      this.$http
        .post(
          appurl.ip +
            "/ylkjservice/services/hander.ashx?action=listexpertdetail",
          {
            ID: this.onledata.ID, //选中课题的ID
            STEPID: stepid_a //选中课题的STEPID
            // EXPERT: this.$store.state.user.EXPERT, //当前登录的EXPERT
            // USERCODE: this.$store.state.user.USERCODE //当前登录的USERCODE
          }
        )
        .then(res => {
          if (res.status == 200) {
            if (res.data.length > 0) {
              _this.data_zj_a = res.data;
              _this.show_a = true;
              let sum = 0;
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].GRADEADIVCE != "") {
                  sum++;
                }
              }
              if (sum != res.data.length) {
                this.isReadOnly = true;
              }
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    //列出专家分数=====专家账号打分进入
    listexpertnum() {
      let _this = this;
      this.df_ID = "";
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=listexpertnum",
          {
            ID: this.onledata.ID, //选中课题的ID
            STEPID: this.onledata.STEP, //选中课题的STEPID
            USERCODE: this.$store.state.user.USERCODE //当前登录的USERCODE
            // EXPERT: this.$store.state.user.EXPERT //当前登录的EXPERT
          }
        )
        .then(res => {
          if (res.status == 200) {
            var data = res.data;
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.df_ID = data[i].ID;
                _this.zjdf_value = data[i].GRADENUM;
                _this.sh_opinion = data[i].GRADEADIVCE;
              }
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    getstep(item) {
      var _this = this;
      this.$http
        .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=liststep", {
          AOTHOR_ID: this.$store.state.user.AOTHOR_ID,
          ISADMIN: this.$store.state.user.ISADMIN,
          STEPID: item.STEP,
          EXPERT: this.$store.state.user.EXPERT
        })
        .then(res => {
          if (res.status == 200) {
            _this.sh_state_3 = [];
            for (var i = 0; i < res.data.length; i++) {
              let obj = {
                label: res.data[i].STEPNAME,
                value: res.data[i].STEPID
              };
              _this.sh_state_3.push(obj);
            }
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "访问失败！",
            duration: 3
          });
        });
    },
    updata(file) {
      var stepid = 0;
      if (
        this.onledata.STEP == 23 ||
        this.onledata.STEP == 22 ||
        this.onledata.STEP == 26 ||
        this.onledata.STEP == 28
      ) {
        stepid = 23;
      } else if (
        this.onledata.STEP == 17 ||
        this.onledata.STEP == 19 ||
        this.onledata.STEP == 21
      ) {
        stepid = 18;
      } else {
        stepid = 8;
        this.$refs.uploadfile.clearFiles();
      }
      //上传
      this.fileAction =
        appurl.ip +
        "/ylkjservice/services/hander.ashx?action=uploadcontractfile&PRJNAME=" +
        this.onledata.PRJNAME +
        "&ID=" +
        this.onledata.ID +
        "&STEPID=" +
        stepid;
    },
    handleUpload(file) {
      // let that = this;
      // this.filenick.push(file.name);
      // return new Promise(function(resolve, reject) {
      //   document.getElementById("confirmbtn").onclick = () => {
      //     that.modal_ok_scht();
      //     resolve();
      //   };
      //   document.getElementById("cancelbtn").onclick = () => {
      //     that.modal_cancel();
      //     reject();
      //   };
      // });
      if (this.onledata.STEP == 17 || this.onledata.STEP == 19) {
        return true;
      } else {
        let FileExt = file.name.replace(/.+\./, ""); //取得文件的后缀名
        if (
          ["docx"].indexOf(FileExt.toLowerCase()) === -1 &&
          ["doc"].indexOf(FileExt.toLowerCase()) === -1
        ) {
          this.$Message.error("请上传以doc或者docx结尾的文件");
          this.successLoad();
          return false;
        } else {
          return true;
        }
      }
    },
    successLoad() {
      this.filenick = [];
    },
    //清除选择信息
    clear_info() {
      this.STEPID = "";
    },
    //获取项目类型
    getType() {
      var _this = this;
      this.$http
        .post(
          appurl.ip + "/ylkjservice/services/hander.ashx?action=listprotype"
        )
        .then(response => {
          if (response.status == 200) {
            _this.Type = [];
            for (var i = 0; i < response.data.length; i++) {
              let obj = {
                label: response.data[i].TYPENAME,
                value: response.data[i].TYPEID
              };
              _this.Type.push(obj);
            }
            _this.typeid = _this.Type[0].value;
          }
        })
        .catch(error => {
          this.$Message.warning({
            content: "请求失败",
            duration: 3
          });
        });
    },

    //格式化时间，获得YY-MM-DD格式的数据
    formatDateTime(timeStamp) {
      var date = new Date(timeStamp);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    }
  },
  // 每5秒刷新一次
  created() {
    this.timer = setInterval(() => {
      this.GetTableData();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
    this.getYear();
    this.initDW();
    //  this.timer = setInterval(() => {
    //   this.GetTableData();
    // }, 5000);
    bus.$on("prjsearch", item => {
      this.keywords = item;
      this.GetTableData();
    });
    bus.$on("to_center", this.GetTableData);
    bus.$on("changeCenter", i => {
      this.listData[i].STEP = "17";
      this.listData[i].STEPNAME = "中期提交";
    });
  },
  directives: {},
  beforeDestroy() {
    bus.$off("center_to");
    bus.$off("prjsearch");
    bus.$off("to_center");
  }
};
</script>



// WEBPACK FOOTER //
// center.vue?340ac012